<template>
  <div class="leading-relaxed space-y-10">
    <section>
      <h2 class="text-2xl font-semibold text-primary mb-3">Ներածություն</h2>
      <p>
        Սույն Գաղտնիության քաղաքականությունը բացատրում է, թե ինչպես է
        MEDIUM.am-ը («մենք», «մեր») հավաքում, օգտագործում և պաշտպանում
        տեղեկատվությունը, երբ դուք օգտվում եք MEDIUM.am հարթակից
        («Ծառայություն»):
      </p>
      <p class="mt-2">
        MEDIUM.am-ը թվային տարածք է, որտեղ հանդիպում են արվեստագետներն ու
        արվեստասերները: Այս քաղաքականությունը նկարագրում է ձեր գաղտնիության
        նկատմամբ մեր պարտավորվածությունը մեր համայնքի և ծառայությունների հետ
        փոխգործակցության ընթացքում:
      </p>
    </section>

    <section>
      <h2 class="text-2xl font-semibold text-primary mb-3">
        Հաշվի և վավերացման տվյալներ
      </h2>
      <p>
        Հատուկ գործառույթներից օգտվելու և ձեր պրոֆիլը կառավարելու համար
        օգտատերերը պետք է ստեղծեն հաշիվ կամ վավերացվեն հարթակում: Օգտատերերը
        կարող են վավերացվել էլեկտրոնային փոստի կամ Google Sign-In-ի միջոցով:
      </p>
      <p class="mt-4 font-medium">
        Անկախ նրանից, թե օգտատերը մուտք է գործում էլեկտրոնային փոստով, Google-ի
        կամ Facebook-ի միջոցով, մենք հավաքում ենք նույն հիմնական տվյալները,
        որոնք անհրաժեշտ են օգտատիրոջ հաշիվը ստեղծելու և կառավարելու համար.
      </p>
      <ul class="list-disc list-inside mt-2 space-y-1 ml-4">
        <li>Անուն</li>
        <li>Ազգանուն</li>
        <li>Էլեկտրոնային փոստի հասցե</li>
        <li>Պրոֆիլի նկար (եթե տրամադրված է)</li>
        <li>Հեռախոսահամար (եթե տրամադրված է)</li>
        <li>Կենսագրություն / Bio (եթե տրամադրված է)</li>
        <li>Ծննդյան ամսաթիվ (եթե տրամադրված է)</li>
      </ul>
      <p class="mt-4 italic">
        Վերոնշյալ տեղեկատվությունից բացի այլ տվյալների հասանելիություն չի
        պահանջվում: Մենք մուտք չունենք ձեր Google-ի կամ Facebook-ի կոնտակտներին,
        օրացույցներին, ընկերների ցուցակներին կամ այլ երրորդ կողմի
        ծառայություններին: Google-ի, Facebook-ի կամ էլեկտրոնային փոստի միջոցով
        մուտք գործելը տրամադրում է միայն հաշվի համար անհրաժեշտ սահմանափակ
        տեղեկատվությունը:
      </p>

      <p class="mt-2">
        Այս տեղեկատվությունն օգտագործվում է բացառապես հաշվի նույնականացման,
        վավերացման, հաճախորդների աջակցության և ծառայությունների հասանելիության
        վերահսկման համար:
      </p>
      <p class="mt-2">
        Վավերացումն իրականացվում է անվտանգ, HTTP-only քուքիների (cookies)
        միջոցով՝ սեսիայի կառավարման համար: Մենք չենք օգտագործում քուքիներ
        գովազդի կամ հետագծման նպատակով:
      </p>
    </section>

    <section>
      <h2 class="text-2xl font-semibold text-primary mb-3">
        Արվեստագետների և արվեստասերների կապը
      </h2>
      <p>
        MEDIUM.am-ը հանդես է գալիս որպես կապող օղակ ստեղծագործողների և արվեստի
        սիրահարների միջև: Մենք հեշտացնում ենք այս կապերը՝ համայնքին ցուցադրելով
        արվեստագետների կողմից տրամադրված մասնագիտական տեղեկատվությունը:
      </p>
      <p class="mt-2">
        <strong>Վճարումներ.</strong> Այս պահին MEDIUM.am-ը չի իրականացնում
        վճարումներ և հանդես չի գալիս որպես վճարային միջնորդ: Օգտատերերի միջև
        կնքված ցանկացած գործարք կամ պայմանավորվածություն իրականացվում է հարթակից
        դուրս և չի կարգավորվում սույն Գաղտնիության քաղաքականությամբ:
      </p>
    </section>

    <section>
      <h2 class="text-2xl font-semibold text-primary mb-3">
        Քուքիներ և տեղային պահեստավորում
      </h2>
      <p>
        MEDIUM.am հարթակն օգտագործում է քուքիներ բացառապես վավերացման և սեսիայի
        կառավարման համար: Տեղային պահեստավորումը (local storage) կարող է
        օգտագործվել օգտատիրոջ ոչ զգայուն նախընտրությունները պահպանելու համար,
        ինչպիսիք են ինտերֆեյսի կարգավորումները կամ լեզվի ընտրությունը:
      </p>
      <p class="mt-2">
        Մենք չենք օգտագործում հետագծող, գովազդային կամ երրորդ կողմի վերլուծական
        քուքիներ:
      </p>
    </section>

    <section>
      <h2 class="text-2xl font-semibold text-primary mb-3">
        Instagram-ի ներմուծում և տվյալների մշակում
      </h2>

      <p>
        MEDIUM.am-ը գրանցված օգտատերերին թույլ է տալիս ներմուծել պատկերներ իրենց
        Instagram-ի պատկերային հրապարակումներից և օգտագործել դրանք
        ստեղծագործությունների սևագրեր ստեղծելու համար։ Այս հնարավորությունն
        օգտագործելու համար օգտատերերը պետք է միացնեն իրենց պատկանող Instagram
        հաշիվը և թույլատրեն MEDIUM.am-ին հասանելիություն ստանալ ինտեգրման համար
        անհրաժեշտ տեղեկություններին։
      </p>

      <p class="mt-2">
        <strong>Instagram հաշվի միացում․</strong> Երբ օգտատերը սեղմում է
        «Միացնել Instagram-ը» կոճակը, անհրաժեշտության դեպքում նրան առաջարկվում է
        մուտք գործել Instagram և Meta-ի թույլտվության գործընթացի միջոցով
        թույլատրել պահանջվող հասանելիությունը։ Համակարգչային դիտարկիչներում
        գործընթացը բացվում է նոր պատուհանում, իսկ շարժական սարքերում օգտատերը
        վերահղվում է Instagram։ Հաջող թույլտվությունից հետո օգտատերը վերադառնում
        է MEDIUM.am-ի վահանակ, որտեղ կարող է տեսնել՝ արդյոք իր Instagram հաշիվը
        միացված է։
      </p>

      <p class="mt-2">
        <strong>Հաշվի տեղեկությունների և տոկենի պահպանում․</strong> Միացումը
        պահպանելու համար MEDIUM.am-ը տվյալների բազայում անվտանգ պահում է միացված
        Instagram հաշվի օգտանունը, հասանելիության տոկենը և դրա վավերացման ու
        ժամկետի ավարտի հետ կապված տեղեկությունները։ Սկզբնական կարճաժամկետ տոկենը
        փոխանակվում է երկարաժամկետ տոկենի հետ, որի վավերականության ժամկետը
        մոտավորապես 60 օր է։ Երբ տոկենի ժամկետն ավարտվում է, միացումն այլևս
        վավեր չէ, և օգտատերը պետք է կրկին միացնի իր Instagram հաշիվը՝ այս
        հնարավորությունից օգտվելու համար։ Օգտատերը ցանկացած պահի կարող է անջատել
        իր Instagram հաշիվը։ Անջատելու դեպքում MEDIUM.am-ում պահվող Instagram
        միացման տեղեկությունները ընդմիշտ ջնջվում են։
      </p>

      <p class="mt-2">
        <strong>Հրապարակումների ստացում և դիտում․</strong> Հաշիվը միացնելուց
        հետո օգտատերը կարող է բացել Instagram-ի ներմուծման պատուհանը՝ ստանալու և
        դիտելու հասանելի պատկերային հրապարակումները։ Ներկայումս MEDIUM.am-ը
        ստանում և ցուցադրում է միայն պատկերային հրապարակումներ․ տեսանյութերը և
        այլ չաջակցվող մեդիա տեսակները այս հնարավորության միջոցով չեն
        ներմուծվում։ Եթե առկա են լրացուցիչ հրապարակումներ, օգտատերը կարող է
        բեռնել դրանք՝ յուրաքանչյուր անգամ մինչև 25 հրապարակում։
      </p>

      <p class="mt-2">
        <strong>Հրապարակումների ժամանակավոր տվյալներ․</strong> Ներմուծման
        պատուհանում դիտելու համար ստացված հրապարակումների տեղեկությունները
        ժամանակավորապես պահվում են հավելվածի դիտարկչի հիշողության մեջ։ Դիտման
        տվյալները չեն պահպանվում մեր տվյալների բազայում և չեն հավաքվում հետին
        պլանում։ Պատուհանը փակելուց հետո այս ժամանակավոր տվյալները մաքրվում են։
        Հրապարակումները ստանալը և դիտելը ինքնին չեն ստեղծում ստեղծագործության
        գրառումներ և չեն պահպանում դիտված հրապարակումները MEDIUM.am-ում։
      </p>

      <p class="mt-2">
        <strong
          >Հրապարակման ներմուծման ժամանակ պահպանվող տեղեկություններ․</strong
        >
        Երբ օգտատերը բացահայտ կերպով ներմուծում է հրապարակումը, MEDIUM.am-ը
        տվյալների բազայում ստեղծում է ստեղծագործության սևագիր։ Սևագիրը ներառում
        է ընտրված հրապարակման պատկերը և նկարագրությունը, սկզբնական Instagram
        հրապարակման հղումը և Instagram հրապարակման ID-ն։ ID-ն օգտագործվում է
        նախկինում ներմուծված հրապարակումները ճանաչելու և նույն հրապարակման
        կրկնակի ներմուծումը կանխելու համար։ Ստեղծագործության գրառումը կապվում է
        օգտատիրոջ MEDIUM.am հաշվի հետ և պահպանվում է որպես սևագիր, մինչև
        օգտատերը լրացնի անհրաժեշտ տեղեկությունները և հրապարակի այն։
      </p>

      <p class="mt-2">
        <strong>Սևագրեր և հրապարակում․</strong> Ներմուծված ստեղծագործությունների
        սևագրերը հանրությանը հասանելի չեն MEDIUM.am-ի պատկերասրահում, մինչև
        օգտատերը չավարտի դրանց լրացումը և չհրապարակի դրանք։ Օգտատերերը կարող են
        խմբագրել սևագրերը մինչև հրապարակումը։ Հրապարակվելուց հետո
        ստեղծագործությունը դառնում է հանրությանը հասանելի՝ MEDIUM.am-ի
        հրապարակման սովորական կարգավորումների և քաղաքականության համաձայն։
      </p>

      <p class="mt-2">
        <strong
          >Ներմուծված հրապարակումների և ստեղծագործությունների հեռացում․</strong
        >
        Օգտատերերը կարող են հեռացնել հրապարակումը Instagram-ի ներմուծման ցանկից՝
        առանց դրա հետ կապված ստեղծագործությունը պարտադիր ջնջելու։ Եթե կապված
        ստեղծագործությունը դեռ սևագիր է, հրապարակումը հեռացնելիս ջնջվում են
        սևագիրը, դրա պահպանված պատկերային ֆայլերը և Instagram ներմուծման
        գրառումը։ Եթե ստեղծագործությունն արդեն հրապարակվել է, ներմուծման ցանկից
        հրապարակումը հեռացնելիս ջնջվում է միայն Instagram ներմուծման գրառումը,
        իսկ հրապարակված ստեղծագործությունը և դրա հետ կապված բովանդակությունը
        մնում են հասանելի MEDIUM.am-ում։ Սա թույլ է տալիս օգտատիրոջը հետագայում
        կրկին ներմուծել նույն Instagram հրապարակումը։
      </p>

      <p class="mt-2">
        Օգտատերերը կարող են նաև առանձին ջնջել իրենց ստեղծագործությունները,
        ներառյալ հրապարակված ստեղծագործությունները՝ MEDIUM.am հարթակի միջոցով։
        Ստեղծագործությունը ջնջելիս դրա հետ կապված Instagram ներմուծման գրառումը
        նույնպես ջնջվում է, եթե այն դեռ գոյություն ունի։ Ստեղծագործության
        ջնջումը չի ջնջում սկզբնական հրապարակումը Instagram-ից։
      </p>

      <p class="mt-2">
        <strong>Նպատակ և տվյալների փոխանցում․</strong> Instagram հաշվի
        տեղեկություններն ու ներմուծված հրապարակումների տվյալներն օգտագործվում են
        միացումը պահպանելու, օգտատիրոջ պահանջով պատկերային հրապարակումներ
        ստանալու և օգտատիրոջ կողմից ընտրված հրապարակումներից
        ստեղծագործությունների սևագրեր ստեղծելու համար։ MEDIUM.am-ը չի վաճառում
        այս տեղեկությունները և չի օգտագործում դրանք կապ չունեցող՝ հետին պլանում
        տվյալների հավաքման նպատակներով։ Instagram-ի տվյալների հասանելիությունը
        կախված է օգտատիրոջ տրամադրած թույլտվություններից և Meta-ի
        թույլտվությունների կառավարման մեխանիզմներից։
      </p>
    </section>

    <section>
      <h2 class="text-2xl font-semibold text-primary mb-3">
        Տվյալների փոխանցում և բացահայտում
      </h2>
      <p>
        Մենք չենք վաճառում, վարձակալությամբ չենք տալիս կամ փոխանակում անձնական
        տվյալները: Տվյալները կարող են բացահայտվել միայն օրենքով սահմանված
        դեպքերում կամ իրավական պահանջներին համապատասխանելու համար: Նման
        դեպքերում բացահայտվում է միայն օրենքով պահանջվող նվազագույն
        տեղեկատվությունը:
      </p>
    </section>

    <section>
      <h2 class="text-2xl font-semibold text-primary mb-3">Ձեր իրավունքները</h2>
      <ul class="list-disc list-inside space-y-2">
        <li>
          Դուք կարող եք ցանկացած պահի պահանջել հասանելիություն ձեր հաշվի
          տեղեկատվությանը:
        </li>
        <li>
          Դուք կարող եք պահանջել ձեր հաշվի և անձնական տվյալների ուղղում կամ
          ջնջում:
        </li>
        <li>
          Դուք կարող եք ցանկացած պահի դուրս գալ հաշվից՝ վավերացման քուքիները
          մաքրելու համար:
        </li>
        <li>Գաղտնիության հետ կապված ցանկացած հարցով կարող եք դիմել մեզ:</li>
      </ul>
    </section>

    <section>
      <h2 class="text-2xl font-semibold text-primary mb-3">Հետադարձ կապ</h2>
      <p>
        Սույն Գաղտնիության քաղաքականության վերաբերյալ հարցերի կամ
        մտահոգությունների դեպքում կարող եք կապվել մեզ հետ հետևյալ հասցեով.
      </p>
      <p class="text-primary font-bold mt-2">contact@medium.am</p>
    </section>
  </div>
</template>
